import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { baseURL } from "../utils/config";
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function ResetPasswordPage() {
  const { userId, token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || password !== confirmPassword) {
      Swal.fire({
        title: "Erreur",
        text: "Les mots de passe ne correspondent pas.",
        icon: "error",
        toast: true,
        position: 'top-right',
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${baseURL}/password-reset-confirm/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, token, password }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Erreur inconnue');

      Swal.fire({
        title: "Mot de passe réinitialisé avec succès",
        icon: "success",
        toast: true,
        timer: 2000,
        position: 'top-right',
        timerProgressBar: true,
        showConfirmButton: false,
      });

      navigate('/login');
    } catch (err) {
      Swal.fire({
        title: err.message || 'Une erreur est survenue.',
        icon: "error",
        toast: true,
        timer: 3000,
        position: 'top-right',
        timerProgressBar: true,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      <section className="d-flex align-items-start justify-content-center px-3" style={{ paddingTop: '100px', minHeight: 'calc(100vh - 60px)' }}>
        <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%', borderRadius: '1rem', animation: 'fadeInUp 0.6s ease' }}>
          <div className="text-center mb-4">
            <h3 className="fw-bold" style={{ color: '#004080' }}>Réinitialiser le mot de passe</h3>
            <p className="text-secondary mt-2 mb-0">Entrez votre nouveau mot de passe.</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-3 position-relative">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Nouveau mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control"
                required
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div className="mb-3 position-relative">
              <input
                type={showConfirm ? 'text' : 'password'}
                placeholder="Confirmer mot de passe"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="form-control"
                required
              />
              <span
                onClick={() => setShowConfirm(!showConfirm)}
                style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
              >
                {showConfirm ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button type="submit" disabled={loading} className="btn w-100 fw-bold" style={{ backgroundColor: '#004080', color: 'white' }}>
              {loading ? 'Enregistrement...' : 'Réinitialiser'}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}

export default ResetPasswordPage;
